import { Box, Container, createTheme, CssBaseline, Grid, Paper, TextField, ThemeProvider, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { renderToString } from 'react-dom/server';
import { GroupUserData } from "../modules/ui/GroupUserData";
import { SelectCustom } from "../modules/ui/SelectCustom";
import { Sexo } from "../modules/ui/Sexo";

import moment from "moment";
import { generateRef } from "../../helpers/generateRef";
import { SelectCountryAndRegion } from "../modules/ui/SelectCountryAndRegion";
import { Footer } from "../modules/ui/Footer";
import { ButtonSubmit } from "../modules/ui/ButtonSubmit";
import { SendingDialog } from "../modules/dialogs/SendingDialog";
import ApplicationBar from "../modules/ui/ApplicationBar";
import Swal from "sweetalert2";
import validator from 'validator';

import QRCode from 'qrcode';
import { sendEmail } from "../../services/sendEmail";
import { setEmailBodyConfirm } from "../../helpers/setEmailBodyConfirm";
import { uploadFile } from "../../services/uploadFile";
import { postIn } from "../../services/crudCustom";
import { CustomDialog } from "../modules/dialogs/CustomDialog";
 

export const Biotecnologia = () => {

    // state para los valores del formulario
    const [formValues, setFormValues] = useState({
        partApellidoPaterno: "",
        partApellidoMaterno: "",
        partNombres: "",
        partCorreo: "",

        partSexo: "",
        partEscolaridad: "",
        partOcupacion: "",
        partCampoTrabajo: "",
        partEspecialidad: "",
        instNombre: "",
        instAcronimo: "",
        instPais: "",
        instEstado: "",
        tipoAsistencia: "",
        tipoRegistro: "",

        trab1Titulo: "",
        trab1Modalidad: "",
        trab1Area: "",
        trab2Titulo: "",
        trab2Modalidad: "",
        trab2Area: "",

        extranjero: false,
        factPais: "",
        requiereFactura: false,
        factNombre: "",
        factRfc: "",
        factCP: "",
        factUsoCFDI: "",
        factRegimenFiscal: "",
        refBancaria: "",
        claveProyRec: "",
        fechaRegistro: "",
        compPago: "",
        fechaPago: "",
    });
    const {
        partApellidoPaterno,
        partApellidoMaterno,
        partNombres,
        partCorreo,
        partSexo,
        partEscolaridad,
        partOcupacion,
        partCampoTrabajo,
        partEspecialidad,
        instNombre,
        instAcronimo,
        instPais,
        instEstado,
        tipoAsistencia,
        tipoRegistro,
        trab1Titulo,
        trab1Modalidad,
        trab1Area,
        trab2Titulo,
        trab2Modalidad,
        trab2Area,
        extranjero,
        factPais,
        requiereFactura,
        factNombre,
        factRfc,
        factCP,
        factUsoCFDI,
        factRegimenFiscal,
        refBancaria,
        claveProyRec,
        fechaRegistro,
        compPago,
        fechaPago,
    } = formValues;

    // state para controlar si es estudiante
    const [isStudent, setIsStudent] = useState(false);

    // states para los fileuploads
    const [fileCredencial, setFileCredencial] = useState({ file: '', });
    const [fileTrab1, setFileTrab1] = useState({ file: '', });
    const [fileTrab2, setFileTrab2] = useState({ file: '', });
    
    const setFileState = (e) => {    
        
        switch (e.target.name) {
            case 'fileCredencial':
                setFileCredencial({ file: e.target.files[0] });    
                break;
            case 'fileTrab1':
                setFileTrab1({ file: e.target.files[0] });    
                break;
            case 'fileTrab2':
                setFileTrab2({ file: e.target.files[0] });    
                break;
        
            default:
                break;
        }
    };

    const [src, setSrc] = useState({ qrdata:"" });

    // Para mostrar un dialogo mientras se envia la info (waiting dialog)
    const [sendingForm, setSendingForm] = useState(false);
    
    // Al modificar un dato en un input
    const handleInputChange = ({ target }) => {
        const { name, value } = target;

        console.log(name, value);

        setFormValues({
            ...formValues,
            [name]: value,
        });
    }
    
    // Al modificar un dato en 'Ocupacion'
    const handleOcupacionChange = ({ target }) => {
        console.log(target.name, target.value);

        const { name, value } = target;
        // Si incluye la palabra 'Estudiante' se establece el state -isStudent-
        value.includes("Estudiante") ? setIsStudent(true) : setIsStudent(false) ;

        setFormValues({
            ...formValues,
            [name]: value,
        });
    }

    // Cada que cambia el pais y estado
    const handleCountryAndRegionChange = ({ country, region }) => {
        console.log(country, region);
        setFormValues({
            ...formValues,
            instPais: country,
            instEstado: region,
        })
    }

    // Validar el formumario
    const isFormValid = () => {

        // Campos obligatorios
        if ( [ partApellidoPaterno, partNombres, partCorreo, partSexo, partEscolaridad, partOcupacion, partCampoTrabajo, partEspecialidad, instNombre, instAcronimo, instPais, instEstado, tipoAsistencia, tipoRegistro ].includes("") ) {
            Swal.fire("Datos incompletos.", "Los campos marcados con [ * ] son obligatorios.", "error");
            return false;
        }

        // Correo valido
        if ( !validator.isEmail(partCorreo) ) {
            Swal.fire("Correo electrónico incorrecto.", "Confirmar el correo electrónico ingresado.", "error");
            return false;
        }

        // Credencial de estudiante
        if ( isStudent && !fileCredencial.file ) {
                Swal.fire("Agregar documento.", `Selecciona un archivo como credencial de estudiante.`, "error");
                return false;
        }

        // Tipo de registro -Presenta1-
        if ((tipoRegistro === 'Presenta1') || (tipoRegistro === 'Presenta2')) {

            // Campos requeridos
            if ( [ trab1Titulo, trab1Modalidad, trab1Area ].includes("") ) {
                Swal.fire("Confirmar datos del trabajo 1", "Los campos marcados con [ * ] son obligatorios.", "error");
                return false;
            }
            
            // Agregar resumen
            if ( !fileTrab1.file ) {
                Swal.fire("Confirmar datos del trabajo 1", "Selecciona un archivo como resumen.", "error");
                return false;
            }

            // Indico archivo pero no es un DOCX 
            const fileSize = fileTrab1.file.size;
            const fullName = fileTrab1.file.name;
            const fileExt = fullName.substring( fullName.lastIndexOf('.') + 1 ).toUpperCase();
            if ( fileExt !== 'DOCX' || fileSize > 2457524 ) {
                Swal.fire("Confirmar datos del trabajo 1", `El resumen debe ser un Word (.docx) menor a 2 MB.`, "error");
                return false;
            }
        }
        // Tipo de registro -Presenta2-
        if ((tipoRegistro === 'Presenta2')) {

            // Campos requeridos
            if ( [ trab2Titulo, trab2Modalidad, trab2Area ].includes("") ) {
                Swal.fire("Confirmar datos del trabajo 2", "Los campos marcados con [ * ] son obligatorios.", "error");
                return false;
            }
            
            // Agregar resumen
            if ( !fileTrab2.file ) {
                Swal.fire("Confirmar datos del trabajo 2", "Selecciona un archivo como resumen.", "error");
                return false;
            }

            // Indico archivo pero no es un DOCX 
            const fileSize = fileTrab2.file.size;
            const fullName = fileTrab2.file.name;
            const fileExt = fullName.substring( fullName.lastIndexOf('.') + 1 ).toUpperCase();
            if ( fileExt !== 'DOCX' || fileSize > 2457524 ) {
                Swal.fire("Confirmar datos del trabajo 2", `El resumen debe ser un Word (.docx) menor a 2 MB.`, "error");
                return false;
            }
        }

        return true;
    }

    // Procesamiento de la info
    const isDataProcessed = async() => {

        // TODO: grabar en la base de datos
        const resultPost = await postIn({ table:'Biotecnologia22', values:formValues });
        console.log(resultPost);

        // Subir credencial de estudiante
        let urlCredencial = '';
        if (isStudent) {
            // const file = fileCredencial;
            // const fileName = `${refBancaria}_credencial.pdf`
            const resultUpload = await uploadFile({ 
                file: fileCredencial, 
                fileName: `${refBancaria}_credencial.pdf` 
            });
            console.log(resultUpload);
            if (resultUpload.exito === 0) {
                return false;
            }
            urlCredencial = `https://eventos.cibnor.mx/registro/apiServiciosSIARF${resultUpload.data}`;
        }

        // Subir trabajo 1
        let urlTrab1 = '';
        if ( formValues.tipoRegistro === 'Presenta1' || formValues.tipoRegistro === 'Presenta2' ) {
            const file = fileTrab1;
            const fileName = `${refBancaria}_trabajo1.docx`
            const resultUpload = await uploadFile({ file, fileName });
            console.log(resultUpload);
            if (resultUpload.exito === 0) {
                return false;
            }
            urlTrab1 = `https://eventos.cibnor.mx/registro/apiServiciosSIARF${resultUpload.data}`;
        }

        // Subir trabajo 2
        let urlTrab2 = '';
        if ( formValues.tipoRegistro === 'Presenta2' ) {
            const file = fileTrab2;
            const fileName = `${refBancaria}_trabajo2.docx`
            const resultUpload = await uploadFile({ file, fileName });
            console.log(resultUpload);
            if (resultUpload.exito === 0) {
                return false;
            }
            urlTrab2 = `https://eventos.cibnor.mx/registro/apiServiciosSIARF${resultUpload.data}`;
        }

        // Enviar correo
        // - Crear cuerpo del correo
        const title = "";
        const urlLogo = 'https://eventos.cibnor.mx/registro/biotecnologia2020/images/logo_biotecnologia2020.png';
        const urlConfirma = `${process.env.REACT_APP_HOMEPAGE}/confirmar-registro/${formValues.refBancaria}`;
        const urlVisualiza = `${process.env.REACT_APP_HOMEPAGE}/visualizar-registro/${formValues.refBancaria}`;

        const aditionalData = 
            "<h3>información adicional:</h3>" +
            "<ul>" +
            ((isStudent) ? `<h4><a href=${urlCredencial}>Credencial de estudiante</a></h4>`: '') +
            (((formValues.tipoRegistro === 'Presenta1') || (formValues.tipoRegistro === 'Presenta2')) ? `<h4><a href=${urlTrab1}>Resumen del trabajo</a></h4>`: '') +
            ((formValues.tipoRegistro === 'Presenta2') ? `<h4><a href=${urlTrab2}>Resumen del segundo trabajo</a></h4>`: '') +
            `<h4>Puede consultar los detalles de su registro en <a href=${urlVisualiza}>este enlace</a> o escaneando el codigo QR</h4>` +
            "</ul>";

        const eventValues = { title, urlConfirma, urlVisualiza, urlLogo, aditionalData };

        const msgbody = renderToString( setEmailBodyConfirm({ formValues, eventValues, src }) );

        // - Se envia el correo
        const emailResult = await sendEmail({
            "toemail": partCorreo,
            "subject": "[Biotecnología] CIBNOR",
            "message": msgbody,
            "replyto": process.env.REACT_APP_TOCC_BIOTECNOLOGIA22,
            "tocc": process.env.REACT_APP_TOCC_BIOTECNOLOGIA22,
        });
        console.log(emailResult);

        return true;
    }

    // Del sweetalert, cuando el usuario decide "continuar"
    const continueConfirmed = async() => {
        console.log("continueConfirmed...");

        // Mostrar waiting dialog 
        setSendingForm(true);
        
        // Se procesa la info
        const resultDataProcessed = await isDataProcessed(); 

        // Ocultar waiting dialog
        setSendingForm(false);

        // Dependiendo el resultado se notifica al usuario...
        if (resultDataProcessed) {
            Swal.fire({
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: 'Ir al sitio web del evento',
                icon: 'success',
                text: 'Consulte su correo electrónico para más información.',
                title: "Sus datos han sido recibidos exitosamente.",
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.replace('https://www.cibnor.gob.mx/eventos-cibnor/2615-congreso-de-biotecnologia-algal');
                }
            }); 
        } else {
            // Notificar del error al usuario y enviar email a developer
            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                title: "Sucedío un error en el servidor.",
                text: 'Disculpe el inconveniente, por favor reintente más tarde.',
                icon: 'error',
                showConfirmButton: false,
                footer: 'El area correspondiente ya ha sido notificada.'
            }); 
            sendEmail({
                "toemail": "jcollins@cibnor.mx",
                "subject": "[Biotecnologia] Error",
                "message": `resultDataProcessed: ${resultDataProcessed} | formValues: ${formValues} | isStudent: ${isStudent} | fileCredencial: ${fileCredencial} | fileTrab1: ${fileTrab1} | fileTrab2: ${fileTrab2} | src: ${src}`,
            });
        }
    }

    // Al enviar formulario
    const handleSubmit = async (event) => {
        event.preventDefault();

        // Validar datos
        if ( !isFormValid() ) {
            return false;
        }

        // Mostrar confirm dialog/waiting dialog
        Swal.fire({
            title: '¿Desea continuar?',
            text: "Por favor, confirme la información ingresada.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Regresar',
        }).then((result) => {
            if (result.isConfirmed) {
                // procesar data
                continueConfirmed();
            }
        })

        console.log( 
            partApellidoPaterno,
            partApellidoMaterno,
            partNombres,
            partCorreo,
            partSexo,
            partEscolaridad,
            partOcupacion,
            partCampoTrabajo,
            partEspecialidad,
            tipoRegistro,
            trab1Titulo,
            trab1Modalidad,
            trab1Area,
            trab2Titulo,
            trab2Modalidad,
            trab2Area,
            instNombre,
            instAcronimo,
            instPais,
            instEstado,
            extranjero,
            factPais,
            requiereFactura,
            factNombre,
            factRfc,
            factCP,
            factUsoCFDI,
            factRegimenFiscal,
            refBancaria,
            claveProyRec,
            fechaRegistro,
            compPago,
            fechaPago,
        );
    };

    useEffect(() => {

        const setInitialValues = () => {
            document.title = "[Biotecnología] CIBNOR";

            // Indicamos el proyecto asignado a este evento
            const PROY_RECURSOS = '20457';
            // Se genera la referencia incluyendo el proyecto            
            const resultGenerateRef = generateRef({ prefix:PROY_RECURSOS });
            // Obtenemos el dato para el campo 'fechaRegistro'
            const dateNow = moment( Date.now() ).format('YYYY-MM-DDTHH:mm:ss');
            // Asignamos los valores al state
            setFormValues({
                ...formValues,
                claveProyRec: PROY_RECURSOS,
                fechaRegistro: dateNow,
                refBancaria: resultGenerateRef,
            })

            const qrString = `${process.env.REACT_APP_HOMEPAGE}/visualizar-registro/${resultGenerateRef}`;

            QRCode.toDataURL( qrString )
            .then( (data) => {
                setSrc( { qrdata:data } ); 
            })

            // /// Pruebas
            // const resultRB = getRefBancaria('204511649349814785');
            // console.log(resultRB);
            // /// Pruebas EOF
        }

        setInitialValues();

    }, [ ])
    

    return (
        <ThemeProvider theme={createTheme()}>
            <Container component="main" maxWidth="sm">
                <CssBaseline />
                <Box
                    sx={{
                        mt: 2,
                        mb: 6,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <ApplicationBar 
                        title="Congreso Internacional de Biotecnología" 
                        subtitle="Registro inicial de participantes" 
                        logo="https://eventos.cibnor.mx/registro/biotecnologia2020/images/logo_biotecnologia2020.png" 
                    />
                </Box>
                {/* Inicio del formulario */}
                <Box
                    component="form"
                    noValidate
                    onSubmit={handleSubmit}
                    sx={{ mt: 2 }}
                    autoComplete="off"
                    maxWidth="sm"
                >
                    {/* Participante */}
                    <Paper elevation={2}>
                        <GroupUserData parentCallback={handleInputChange}
                            title='Datos generales' 
                            userEmail='partCorreo' 
                            userEmailLabel='Correo electrónico' 
                            userFatherName='partApellidoPaterno' 
                            userFatherNameLabel='Apellido Paterno' 
                            userMotherName='partApellidoMaterno' 
                            userMotherNameLabel='Apellido Materno' 
                            userName='partNombres' 
                            userNameLabel='Nombre(s)' 
                            variant='outlined' 
                        />
                        <Grid container spacing={2} sx={{ pb: 2, pl: 2, pr: 2 }}>
                            <Grid item xs={6} >
                                <Sexo
                                    label={"Sexo"}
                                    name={"partSexo"}
                                    parentCallback={handleInputChange}
                                    required
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <SelectCustom 
                                    parentCallback={handleInputChange}
                                    name={"partEscolaridad"}
                                    label={"Escolaridad"}
                                    options={[
                                        {value:'Preparatoria', label:'Preparatoria'},
                                        {value:'Licenciatura', label:'Licenciatura'},
                                        {value:'Maestría', label:'Maestría'},
                                        {value:'Doctorado', label:'Doctorado'},
                                        {value:'Posdoctorado', label:'Posdoctorado'},
                                    ]}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <SelectCustom 
                                    parentCallback={handleOcupacionChange}
                                    name={"partOcupacion"}
                                    label={"Ocupación"}
                                    options={[
                                        {value:'Estudiante de licenciatura', label:'Estudiante de licenciatura'},
                                        {value:'Estudiante de maestría', label:'Estudiante de maestría'},
                                        {value:'Estudiante de doctorado', label:'Estudiante de doctorado'},
                                        {value:'Posdoctorado', label:'Posdoctorado'},
                                        {value:'Investigador', label:'Investigador'},
                                        {value:'Profesor', label:'Profesor'},
                                        {value:'Catedrático CONACYT', label:'Catedrático CONACYT'},
                                        {value:'Técnico académico', label:'Técnico académico'},
                                        {value:'Empresario', label:'Empresario'},
                                    ]}
                                    required
                                />
                            </Grid>
                            {/* Credencial de estudiante */}
                            <Grid item xs={12} sx={{ display:(isStudent) ? 'flex' : 'none' }} >
                                <TextField
                                    type={"file"}
                                    fullWidth
                                    name="fileCredencial"
                                    variant="standard"
                                    onChange={e => setFileState(e)}
                                    helperText="Agregar credencial en formato PDF *"
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <SelectCustom 
                                    parentCallback={handleInputChange}
                                    name={"partCampoTrabajo"}
                                    label={"Campo de trabajo"}
                                    options={[
                                        {value:'Microalgas', label:'Microalgas'},
                                        {value:'Macroalgas', label:'Macroalgas'},
                                        {value:'Ambos', label:'Ambos'},
                                    ]}
                                    required
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <TextField
                                    fullWidth
                                    id="partEspecialidad"
                                    label={`Especialidad`}
                                    name="partEspecialidad"
                                    required
                                    size="small"
                                    value={partEspecialidad}
                                    onChange={handleInputChange}
                                    variant='outlined'
                                />
                            </Grid>

                            {/* Institución laboral o académica */}
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" sx={{ pt: 4, fontWeight: 500 }} >
                                    Institución laboral o académica
                                </Typography>
                            </Grid>
                            <Grid item xs={8} >
                                <TextField
                                    fullWidth
                                    id="instNombre"
                                    label={`Nombre de la institución`}
                                    name="instNombre"
                                    required
                                    size="small"
                                    value={instNombre}
                                    onChange={handleInputChange}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item xs={4} >
                                <TextField
                                    fullWidth
                                    id="instAcronimo"
                                    label={`Acrónimo`}
                                    name="instAcronimo"
                                    required
                                    size="small"
                                    value={instAcronimo}
                                    onChange={handleInputChange}
                                    variant='outlined'
                                />
                            </Grid>
                            {/* Seleccionar pais y estado - incluye grid container */}
                            <SelectCountryAndRegion parentCallback={handleCountryAndRegionChange} 
                                variant="outlined" 
                            />
                        </Grid>
                    </Paper>
                    {/* Tipo de registro */}
                    <Paper elevation={2} >
                        <Grid container spacing={2} sx={{ pb: 2, pl: 2, pr: 2, mt: 2 }} >
                            <Grid item xs={12} >
                                <SelectCustom 
                                    parentCallback={handleInputChange}
                                    name={"tipoAsistencia"}
                                    label={"Tipo de asistencia"}
                                    options={[
                                        {value:'Presencial', label:'Presencial'},
                                        {value:'Virtual', label:'Virtual'},
                                    ]}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <SelectCustom 
                                    parentCallback={handleInputChange}
                                    name={"tipoRegistro"}
                                    label={"Tipo de registro"}
                                    options={[
                                        {value:'Asistente', label:'Asistente'},
                                        {value:'Presenta1', label:'Presentaré un trabajo'},
                                        {value:'Presenta2', label:'Presentaré dos trabajos'},
                                    ]}
                                    required
                                />
                            </Grid>
                        </Grid>
                        {/* Trabajo 1 */}
                        <Grid container 
                            spacing={1} 
                            sx={{ 
                                p: 2, 
                                display:(formValues.tipoRegistro === 'Presenta1' || formValues.tipoRegistro === 'Presenta2') ? 
                                'flex' : 
                                'none'
                            }} 
                        >
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 500 }} >
                                    { (formValues.tipoRegistro === 'Presenta2') ? 'Datos del trabajo 1' : 'Datos del trabajo' }
                                </Typography>
                            </Grid>
                            <Grid item xs={12} >
                                <TextField
                                    fullWidth
                                    id="trab1Titulo"
                                    label={`Título`}
                                    name="trab1Titulo"
                                    required
                                    size="small"
                                    value={trab1Titulo}
                                    onChange={handleInputChange}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <SelectCustom 
                                    parentCallback={handleInputChange}
                                    name={"trab1Modalidad"}
                                    label={"Modalidad"}
                                    options={[
                                        {value:'Oral', label:'Oral'},
                                        {value:'Cartel', label:'Cartel'},
                                    ]}
                                    required
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <SelectCustom 
                                    parentCallback={handleInputChange}
                                    name={"trab1Area"}
                                    label={"Area"}
                                    options={[
                                        {value:'Acuicultura', label:'Acuicultura'},
                                        {value:'Algas Nocivas y Tóxicas', label:'Algas Nocivas y Tóxicas'},
                                        {value:'Biodiversidad', label:'Biodiversidad'},
                                        {value:'Biogeografía', label:'Biogeografía'},
                                        {value:'Biología Celular y Molecular', label:'Biología Celular y Molecular'},
                                        {value:'Bioproductos de alto valor', label:'Bioproductos de alto valor'},
                                        {value:'Biotecnología y Ficología Aplicada', label:'Biotecnología y Ficología Aplicada'},
                                        {value:'Ecología', label:'Ecología'},
                                        {value:'Fisiología y Fitoquímica', label:'Fisiología y Fitoquímica'},
                                        {value:'Taxonomía y Filogenia', label:'Taxonomía y Filogenia'},
                                    ]}
                                    required
                                />
                            </Grid>
                            {/* Resumen */}
                            <Grid item xs={12} >
                                <TextField
                                    type={"file"}
                                    fullWidth
                                    name="fileTrab1"
                                    variant="standard"
                                    onChange={e => setFileState(e)}
                                    helperText="Adjuntar archivo Word (.docx) de tamaño menor a 2 MB. *"
                                />
                            </Grid>
                        </Grid>
                        {/* Trabajo 2 */}
                        <Grid container 
                            spacing={1} 
                            sx={{ 
                                p: 2, 
                                display:(formValues.tipoRegistro === 'Presenta2') ? 
                                'flex' : 
                                'none'
                            }} 
                        >
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 500 }} >
                                    Datos del trabajo 2
                                </Typography>
                            </Grid>
                            <Grid item xs={12} >
                                <TextField
                                    fullWidth
                                    id="trab2Titulo"
                                    label={`Título`}
                                    name="trab2Titulo"
                                    required
                                    size="small"
                                    value={trab2Titulo}
                                    onChange={handleInputChange}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <SelectCustom 
                                    parentCallback={handleInputChange}
                                    name={"trab2Modalidad"}
                                    label={"Modalidad"}
                                    options={[
                                        {value:'Oral', label:'Oral'},
                                        {value:'Cartel', label:'Cartel'},
                                    ]}
                                    required
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <SelectCustom 
                                    parentCallback={handleInputChange}
                                    name={"trab2Area"}
                                    label={"Area"}
                                    options={[
                                        {value:'Acuicultura', label:'Acuicultura'},
                                        {value:'Algas Nocivas y Tóxicas', label:'Algas Nocivas y Tóxicas'},
                                        {value:'Biodiversidad', label:'Biodiversidad'},
                                        {value:'Biogeografía', label:'Biogeografía'},
                                        {value:'Biología Celular y Molecular', label:'Biología Celular y Molecular'},
                                        {value:'Bioproductos de alto valor', label:'Bioproductos de alto valor'},
                                        {value:'Biotecnología y Ficología Aplicada', label:'Biotecnología y Ficología Aplicada'},
                                        {value:'Ecología', label:'Ecología'},
                                        {value:'Fisiología y Fitoquímica', label:'Fisiología y Fitoquímica'},
                                        {value:'Taxonomía y Filogenia', label:'Taxonomía y Filogenia'},
                                    ]}
                                    required
                                />
                            </Grid>
                            {/* Resumen */}
                            <Grid item xs={12} >
                                <TextField
                                    type={"file"}
                                    fullWidth
                                    name="fileTrab2"
                                    variant="standard"
                                    onChange={e => setFileState(e)}
                                    helperText="Adjuntar archivo Word (.docx) de tamaño menor a 2 MB. *"
                                    
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    {/* Boton submit */}
                    <ButtonSubmit label={`Enviar`} />
                    {/* Footer */}
                    <Footer />

                </Box>
                {/* Dialogo de registro cerrado */}
                <CustomDialog 
                    show={true} 
                    title={'¡Gracias por su interes!'} 
                    content={'El registro a este evento ya se encuentra cerrado.'} 
                />
            </Container>
            {/* Dialogo 'enviando la informacion' */}
            <SendingDialog show={sendingForm} />
            
        </ThemeProvider>
    );
};
